const textCases = {
    core: {
        none: "none",
        uppercase: "uppercase",
        lowercase: "lowercase",
        capitalize: "capitalize",
    },
};
export default textCases;
//# sourceMappingURL=textCases.js.map